import {useMenuTriggerState as $1Y8YR$useMenuTriggerState} from "@react-stately/menu";
import {useSingleSelectListState as $1Y8YR$useSingleSelectListState} from "@react-stately/list";
import {useState as $1Y8YR$useState} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2cf721c498a73112$exports = {};

$parcel$export($2cf721c498a73112$exports, "useSelectState", () => $2cf721c498a73112$export$5159ec8b34d4ec12);



function $2cf721c498a73112$export$5159ec8b34d4ec12(props) {
    let triggerState = $1Y8YR$useMenuTriggerState(props);
    let listState = $1Y8YR$useSingleSelectListState({
        ...props,
        onSelectionChange: (key)=>{
            if (props.onSelectionChange != null) props.onSelectionChange(key);
            triggerState.close();
        }
    });
    let [isFocused, setFocused] = $1Y8YR$useState(false);
    return {
        ...listState,
        ...triggerState,
        open () {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0) triggerState.open();
        },
        toggle (focusStrategy) {
            if (listState.collection.size !== 0) triggerState.toggle(focusStrategy);
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}




export {$2cf721c498a73112$export$5159ec8b34d4ec12 as useSelectState};
//# sourceMappingURL=module.js.map
